module.exports = __webpack_public_path__ + "Feed.png";